import AppPageEmpty from '@/components/app-page/index-empty.vue';

export default [
  {
    path: '/analyze',
    name: 'Analyze',
    component: AppPageEmpty,
    meta: {
      title: '用户细查',
      style: 'user',
    },
    children: [
      {
        path: 'users',
        name: 'AnalyzeUsers',
        component: () => import('@/views/analyze/users/index.vue'),
        meta: {
          title: '用户细查',
          style: 'user',
          activeMenu: '/analyze/users',
          isUseEnvInfo: true,
          isUseAppInfo: true,
        },
      },
    ],
  },
  // {
  //   path: '/expand',
  //   component: AppPage,
  //   children: [
  //     {
  //       path: '',
  //       name: 'Expand',
  //       component: () => import('@/views/Expand.vue'),
  //       meta: {
  //         title: '扩展字段',
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: '/errors',
  //   component: AppPage,
  //   children: [
  //     {
  //       path: '',
  //       name: 'Errors',
  //       component: () => import('@/views/Errors.vue'),
  //       meta: {
  //         title: '错误统计',
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: "/chart",
  //   component: AppPage,
  //   children: [
  //     {
  //       path: '',
  //       name: 'Chart',
  //       component: () => import('@/views/Chart.vue'),
  //       meta: {
  //         title: '数据统计',
  //       },
  //     }
  //   ],
  // },
  // {
  //   path: '/warn',
  //   component: AppPage,
  //   children: [
  //     {
  //       path: '',
  //       name: 'Warn',
  //       component: () => import('@/views/Warn.vue'),
  //       meta: {
  //         title: '报警管理',
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: '/size',
  //   component: AppPage,
  //   children: [
  //     {
  //       path: '',
  //       name: 'Size',
  //       component: () => import('@/views/Size.vue'),
  //       meta: {
  //         title: '管理',
  //       },
  //     },
  //   ],
  // },
];
